import './answer-form.less';
import PropTypes from 'prop-types';
import React from 'react';
import {Field, reduxForm } from 'redux-form';
import cn from 'classname';

import TextField from '../../shared/form-elements/textarea';

const Form = ({
	handleSubmit,
	submitAnswer,
	can,
	toggleCloseForm,
	isClosed,
	intl
}) => {
	return (
		<div className="ext-support__answers-form">
			<form
				className="ui-form answer-form"
				onSubmit={handleSubmit(data => submitAnswer(data))}>
				<div className="ui-form__element">
					<Field
						name="text"
						placeholder="Answer"
						component={TextField}
						showLabel={false}
						disabled={isClosed} />
				</div>
				<div className="ui-form__element control-wrap">
					{ can('answer') && (
						<button
							type="submit"
							disabled={isClosed}
							className={cn({
								'ui-btn': true,
								'ui-btn-primary': !isClosed
							})}>{intl('Send answer')}</button>
					)
					}

					{ can('closeTicket') && !isClosed && (
						<button
							className="ui-btn ui-btn-cancel"
							onClick={e => {
								e.preventDefault();
								toggleCloseForm();
							}}>{ intl('Close ticket') }</button>
					) }
				</div>
			</form>
		</div>
	);
};

Form.propTypes = {
	handleSubmit: PropTypes.func,
	submitAnswer: PropTypes.func,
	intl: PropTypes.func,
	isClosed: PropTypes.bool,
	toggleCloseForm: PropTypes.func,
	can: PropTypes.func
};

export default reduxForm({
	form: 'extSupportForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/external-threads/components/answer-form.js